<app-page-header [heading]="'New Sale'" [icon]="'fa-cart-plus'" style="height:100px;"></app-page-header>
<ng-template #rt let-r="result" let-t="term">
  <ngb-highlight [result]="r.HSN_CODE+'  '+r.DDC_CODE+' - '+r.TRADE_NAME" [term]="t"></ngb-highlight>
</ng-template>
<div *ngIf="user_rights.ADD == '1'" class="page-panel">
  <div class="row">
    <div class="form-group col-lg-3">
      <label>Customer Name</label><span class="text-danger">&nbsp;*</span>
      <ngx-select-dropdown (change)="getCustomer()" [(ngModel)]="customer_data"
                           [config]="utils.dropConfig({displayKey: 'CUSTOMER_NAME',placeholder: 'Select Customer',searchOnKey: 'CUSTOMER_NAME'})"
                           [disabled]="sale.sale_id > 0" [multiple]="false"
                           [options]="customer_options" class="form-control  size"
                           name="customer"></ngx-select-dropdown>
    </div>
    <div class="form-group col-lg-3">
      <label>Date</label><span class="text-danger">&nbsp;*</span>
      <input (ngModelChange)="sale.sale_date = $event" [max]="getToday()" [ngModel]="sale.sale_date | date:'yyyy-MM-dd'"
             class="form-control " id="date" name="date" type="date">
    </div>

    <div class="form-group col-lg-3">
      <label>Order No</label><span class="text-danger">&nbsp;*</span>
      <input [(ngModel)]="sale.order_no" class="form-control " maxlength="10" name="order_no"
             readonly="readonly" tabindex="-1"
             type="text">
    </div>
    <div class="form-group col-lg-3">
      <label>VAT No</label>
      <input [(ngModel)]="sale.vat_no" [readOnly]="true" class="form-control " maxlength="10"
             name="state_code"
             type="text">
    </div>
    <div *ngIf="sale.customer_address != ''" class="form-group col-lg-3">
      <label>Customer Address</label>
      <textarea [(ngModel)]="sale.customer_address" class="form-control " name="address" readonly
                style="font-size: 12px;"></textarea>
    </div>
    <div class="form-group col-lg-3">
      <label>Slab</label>
      <select (change)="cleardata()" [(ngModel)]="sale.slab" [disabled]="sale.sale_id > 0"
              class="form-control  custom-select custom-select-sm" id="sel_dr" name="sel_dr">
        <option value="">Select Slab</option>
        <option value="1">Slab A</option>
        <option value="2">Slab B</option>
        <option value="3">Slab C</option>
      </select>
    </div>
    <div class="form-group col-lg-6">
      <label>Payment Type</label>
    <div class="col-12">
  <label class="checkbox-inline">
    <input type="checkbox"
           (change)="selectCoinPaymentType(1, $event)"
           [checked]="sale.payment_type && sale.payment_type?.includes(1)"> 
    &nbsp;Cash&nbsp;
  </label>&nbsp;&nbsp;&nbsp;

  <label class="checkbox-inline">
    <input type="checkbox"
           (change)="selectCoinPaymentType(0, $event)"
           [checked]="sale.payment_type && sale.payment_type?.includes(0)">
    &nbsp;Card&nbsp;
  </label>&nbsp;&nbsp;&nbsp;

  <label class="checkbox-inline">
    <input type="checkbox"
           (change)="selectCoinPaymentType(2, $event)"
           [checked]="sale.payment_type && sale.payment_type?.includes(2)">
    &nbsp;Cheque&nbsp;
  </label>&nbsp;&nbsp;&nbsp;

  <label class="checkbox-inline">
    <input type="checkbox"
           (change)="selectCoinPaymentType(3, $event)"
           [checked]="sale.payment_type && sale.payment_type?.includes(3)">
    &nbsp;Bank&nbsp;
  </label>&nbsp;&nbsp;&nbsp;

  <label class="checkbox-inline">
    <input type="checkbox"
           (change)="selectCoinPaymentType(4, $event); checkCreditNote()"
           [checked]="sale.payment_type && sale.payment_type?.includes(4)">
    &nbsp;Credit Note
  </label>

  <!-- Show extra input fields dynamically -->
  <div class="row">
    <ng-container *ngIf="sale.payment_type?.includes(4)">
      <div class="col-lg-4">
            <ngx-select-dropdown (change)="setCreditNote($event)" [(ngModel)]="sale.credit_note_no"
                  [config]="utils.dropConfig({displayKey: 'CN_NO',placeholder: 'Credit Note',searchOnKey: 'CN_NO'})"
                  [multiple]="false" [options]="creditnote_options" 
                  class="form-control size mt-2" name="credit_note_no"></ngx-select-dropdown>
            <p class="text-center mt-1" style="font-size: 15px;">Amount&nbsp;:&nbsp;{{sale.credit_note_amount ?? 0}}</p>
      </div>
    </ng-container>

    <ng-container *ngIf="sale.payment_type?.includes(2)">
      <div class="col-lg-4">
        <input [(ngModel)]="sale.chequeno" class="form-control mt-2" maxlength="20" name="cheque"
            placeholder="Cheque number" type="text">
      </div>
    </ng-container>

    <ng-container *ngIf="sale.payment_type?.includes(0)">
      <div class="col-lg-4">
        <input [(ngModel)]="sale.cardno" class="form-control mt-2" maxlength="20" name="card"
            placeholder="Card number" type="text">
      </div>
    </ng-container>
  </div>
</div>

    </div>
    <div class="form-group col-lg-3">
      <label>Shipping Address</label>
      <textarea [(ngModel)]="sale.shipping_address" class="form-control " name="shipping_address"
                style="font-size: 12px;"></textarea>
    </div>
    <div class="form-group col-lg-3">
      <label>Remarks</label>
      <input [(ngModel)]="sale.remark" class="form-control " name="remark" type="text">
    </div>
  </div>
  <hr>
  <div class="clearfix"></div>
  <div class=" form-group">
    <table class=" table   table-bordered">
      <thead>
      <tr class="text-center">
        <th width="1%">FOC</th>
        <th>#</th>
        <th width="20%">Item Information<span class="text-danger">&nbsp;*</span></th>
        <th>Warehouse<span class="text-danger">&nbsp;*</span></th>
        <th>Ava.Qty</th>
        <th>UOM</th>
        <th>MRP</th>
        <th>Retail Price</th>
        <th>Qty<span class="text-danger">&nbsp;*</span></th>
        <th>Total<span class="text-danger">&nbsp;*</span></th>
        <th *ngIf="sale.sale_id == 0">*</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let i of utils.buildArray(sale_details.length)">
        <td class="text-center">
          <label>
            <input (change)="giveMarkFOC(i)"
                   [(ngModel)]="sale.mark_free_of_cost[i]"
                   [checked]="sale.mark_free_of_cost[i] == true"
                   name="mark_free_of_cost{{i}}"
                   type="checkbox"/>
          </label>
        </td>
        <td class="text-center">{{ 1 + i }}</td>
        <td>
          <input (selectItem)="set_item_medicine($event,i)" [(ngModel)]="sale.medicine_data[i]"
                 [class.is-invalid]="searchFailed"
                 [disabled]="sale.sale_id > 0" [inputFormatter]="formatter" [ngModelOptions]="{standalone: true}"
                 [ngbTypeahead]="medicine_search"
                 [resultTemplate]="rt" class="form-control" id="typeahead-http{{i}}"
                 placeholder="Search Particular Name...." style="height: 29px;"
                 type="text"/>
        </td>
        <td>
          <select (change)="availableqty(i)" *ngIf="sale.sale_id == 0" [(ngModel)]="sale.warehouse_details_id_arr[i]"
                  class="form-control  custom-select custom-select-sm" name="warehouse_id">
            <option value=''>Select Warehouse</option>
            <option *ngFor="let data of sale.warehouses_data[i];"
                    value="{{data.WAREHOUSE_STOCK_DETAIL_ID}}">{{ data.WAREHOUSE }}
            </option>
          </select>
          <input *ngIf="sale.sale_id > 0" [(ngModel)]="sale.warehouse_arr[i]" [readOnly]="true"
                 class="form-control text-center "
                 name="warehouse_arr{{i}}" tabindex="-1" type="text">
        </td>
        <td>
          <input [(ngModel)]="sale.ava_quantity_arr[i]" [readOnly]="true"
                 class="form-control text-center "
                 name="ava_quantity_arr{{i}}" tabindex="-1" type="text">
        </td>
        <td>
          <input [(ngModel)]="sale.uom_arr_name[i]" [readOnly]="true" class="form-control"
                 name="uom_arr_name{{i}}" tabindex="-1" type="text">
        </td>
        <td>
          <input [(ngModel)]="sale.MRP[i]" [readOnly]="true" class="form-control text-right"
                 name="MRP{{i}}" tabindex="-1" type="text">
        </td>
        <td>
          <input (change)="totalAmount();totalprice();" (focusout)="totalAmount();totalprice()"
                 [(ngModel)]="sale.unitprice_arr[i]" [disabled]="sale.mark_free_of_cost[i] == true"
                 class="form-control text-right " id="unitprice_arr{{i}}" name="unitprice_arr{{i}}"
                 type="text">
        </td>
        <td>
          <input (focusout)="totalprice();totalAmount();" [(ngModel)]="sale.quantity_arr[i]"
                 [disabled]="sale.sale_id > 0" class="form-control text-center" maxlength="7"
                 name="quantity_arr{{i}}"
                 type="text">
        </td>
        <td>
          <input [(ngModel)]="sale.total_arr[i]" [readOnly]="true" class="form-control text-right "
                 name="total_arr{{i}}" tabindex="-1" type="text">
        </td>
        <td *ngIf="sale.sale_id == 0">
          <button (click)="addrow(i)" *ngIf="i == sale_details.length-1" alt="Add New data"
                  class="btn btn-success btn-sm "
                  title="Add New data" type="button"><i class="fa fa-plus"
                                                        style="color: white;"></i></button>
          <button (click)="deleterow(i)" *ngIf="i  != sale_details.length-1" alt="Delete data"
                  class="btn btn-danger  btn-sm "
                  title="Delete data" type="button"><i class="fa fa-trash"
                                                       style="color: white;"></i>
          </button>
        </td>
      </tr>
      </tbody>
      <tfoot>
        <tr>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
          <td class="text-right"> 
            <label class="text-right">Cash</label>
            <input [readOnly]="!sale.payment_type?.includes(1)" placeholder="Amount" [(ngModel)]="sale.cash_amount" class="form-control text-right" name="cash_amount" type="text">
          </td>
          <td class="text-right">
              <label class="text-right">Card</label>
              <input [readOnly]="!sale.payment_type?.includes(0)" placeholder="Amount" [(ngModel)]="sale.card_amount" class="form-control text-right" name="card_amount" type="text">
            </td>
          <td class="text-right">
            <label class="text-right">Cheque</label>
            <input [readOnly]="!sale.payment_type?.includes(2)" placeholder="Amount" [(ngModel)]="sale.cheque_amount" class="form-control text-right" name="cheque_amount" type="text">
          </td>
          <td class="text-right">
            <label class="text-right">Bank</label>
            <input [readOnly]="!sale.payment_type?.includes(3)" placeholder="Amount" [(ngModel)]="sale.bank_amount" class="form-control text-right" name="bank_amount" type="text">
          </td>
          <td class="text-right">
              <label class="text-right">Credit Note</label>
              <!-- <input [readOnly]="true" placeholder="Amount" [(ngModel)]="sale.credit_note_amount" class="form-control text-right" name="credit_note_amount" type="text"> -->
               <div class="text-right mt-2">{{sale.credit_note_amount ?? 0}}</div>
            </td>
          <td class="text-right"><b>Grand Total</b></td>
          <td class="text-right"><b>{{sale.grand_tot ?? 0 | number:'1.2-2'}}</b></td>
        </tr>

      </tfoot>
    </table>
    <div class="clearfix"></div>
  </div>
  <div class="clearfix"></div>
  <div class="row container">
    <div class="col-lg-7 pull-right">
      <button (click)="saveSale()" *ngIf="user_rights.ADD == '1' && sale.sale_id == 0"
              class="btn  btn-info btn-sm ng-star-inserted" type="button">&nbsp;Save&nbsp;
      </button>&nbsp;&nbsp;
      <button (click)="Updatesale()" *ngIf="user_rights.EDIT == '1' && sale.sale_id > 0"
              class="btn  btn-info btn-sm ng-star-inserted" type="button">&nbsp;Update&nbsp;
      </button>&nbsp;&nbsp;
    </div>
  </div>
</div>
